import TreeStructure from "./components/TreeStructure";

const Plugin = {
  install(app) {
    app.component("tree-structure", TreeStructure);
  },
};

export default Plugin;
